// @ts-nocheck
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  InputLabel,
  Modal,
  Paper,
  Slider,
  TextField,
  Typography,
} from "@mui/material";
import LocAirport from "./../../assets/svgs/airport-loc.svg";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import PropTypes from "prop-types";
import { useState } from "react";
import { useMemo } from "react";
import styles from "./filters.module.css";
import { apiRequest } from "../../services/apiService";
import {
  CustomAirportChip,
  CustomIconButton,
} from "../Custom/CustomIconButton";
import _ from "lodash";

export default function ContractorAirportFilter({
  airportFilters,
  setAirportFilters,
  showLabel = false,
  smallIcon = false,
}) {
  const initialAirportFilters = useMemo(() => {
    return {
      localAirports: [],
      additionalAirports: [],
      sameAsLocal: false,
      radius: 50,
      status: false,
    };
  }, []);
  // const [airportFilters, setAirportFilters] = useState(initialAirportFilters);
  const [airportList, setAirportList] = useState({
    isLoading: false,
    list: [],
  });

  function buttonClickHandler(e) {
    setAirportFilters((prev) => ({
      ...prev,
      status: true,
    }));
  }

  const filterCount = useMemo(() => {
    return _.sum([
      airportFilters?.localAirports?.length,
      airportFilters?.additionalAirports?.length,
    ]);
  }, [airportFilters]);

  useMemo(async () => {
    setAirportList({ isLoading: true, list: [] });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getAirports",
      isToken: true,
    });

    if (response?.status === 200) {
      setAirportList({ isLoading: false, list: response?.data?.data });
    } else if (response?.status !== 200 || error) {
      setAirportList({ isLoading: false, list: [] });
    }
  }, []);

  return (
    <>
      {smallIcon ? (
        <CustomIconButton
          sx={{
            // position: "relative",
            bgcolor: getCssVariableHandler({
              variableName: "--primary-pink-hex",
            }),
            p: "0.35rem",
            "&:hover": {
              bgcolor: getCssVariableHandler({
                variableName: "--primary-pink-hex",
              }),
            },
          }}
          onClick={buttonClickHandler}
        >
          {filterCount > 0 ? (
            <Typography
              sx={{
                position: "absolute",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                top: "-0.35rem",
                right: "-0.35rem",
                borderRadius: "50%",
                p: "0.2rem",
                height: "1.2em",
                border: "1px solid",
                borderColor: getCssVariableHandler({
                  variableName: "--white-rgb",
                }),
                aspectRatio: 1,
                bgcolor: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
              }}
            >
              {filterCount}
            </Typography>
          ) : null}
          <img
            src={LocAirport}
            alt={"Airport Image"}
            style={{ height: "1.45rem", width: "auto", position: "relative" }}
          />
        </CustomIconButton>
      ) : (
        <Button
          sx={{
            minHeight: "3.125rem",
            ml: "0.5rem",
            border: `1px solid ${getCssVariableHandler({ variableName: "--white-rgb" })}`,
          }}
          onClick={buttonClickHandler}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            {showLabel ? <Typography>Airports</Typography> : null}
            <img
              src={LocAirport}
              alt={"Airport Image"}
              style={{ height: "1.75rem", width: "auto", position: "relative" }}
            />
            {filterCount > 0 ? (
              <Typography
                sx={{
                  position: "absolute",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  top: "-0.35rem",
                  right: "-0.35rem",
                  borderRadius: "50%",
                  p: "0.2rem",
                  height: "1.2em",
                  border: "1px solid",
                  borderColor: getCssVariableHandler({
                    variableName: "--white-rgb",
                  }),
                  aspectRatio: 1,
                  bgcolor: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                }}
              >
                {filterCount}
              </Typography>
            ) : null}
            <Divider
              orientation="vertical"
              sx={{
                borderWidth: "0.5px",
                height: "1.75rem",
                borderRadius: "0.5rem",
                borderColor: getCssVariableHandler({
                  variableName: "--white-rgb",
                }),
              }}
            />
            <Typography
              component="span"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "baseline",
                gap: "0.25rem",
                bgcolor: getCssVariableHandler({ variableName: "--white-rgb" }),
                borderRadius: "0.5rem",
                px: "0.25rem",
                py: "0.25rem",
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
              }}
            >
              <Typography
                component="span"
                sx={{
                  display: "inline-flex",
                  fontWeight: 500,
                  color: "inherit",
                  lineHeight: 1,
                }}
              >
                {airportFilters?.radius}
              </Typography>
              <Typography
                component="span"
                sx={{
                  display: "inline-flex",
                  fontSize: "0.75rem",
                  color: "inherit",
                  lineHeight: 1,
                }}
              >
                KM
              </Typography>
            </Typography>
          </Box>
        </Button>
      )}

      {/* NOTE: modal for the airport */}
      <AirportFilterModal
        open={airportFilters?.status}
        handleClose={() => {
          setAirportFilters((prev) => ({ ...prev, status: false }));
        }}
        setAirportFilters={setAirportFilters}
        values={airportFilters}
        options={airportList?.list}
        isLoading={airportList?.isLoading}
      />
    </>
  );
}

ContractorAirportFilter.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  airportFilters: PropTypes.object,
  setAirportFilters: PropTypes.func,
  showLabel: PropTypes.bool,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 4,
  minWidth: "700px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  "@media (max-width: 600px)": {
    minWidth: "96vw",
    maxHeight: "96vh",
    width: "97vw",
    overflowY: "auto",
  },
};

const AirportFilterModal = ({
  open,
  handleClose,
  setAirportFilters,
  values,
  options,
  isLoading,
}) => {
  function onClose() {
    handleClose();
  }

  function localAirportOptionClick(val) {
    if (values?.localAirports?.find((item) => item?._id == val?._id)) return;
    setAirportFilters((prev) => ({
      ...prev,
      localAirports: [...(prev?.localAirports || []), val],
    }));
  }

  function deleteLocalAirport(id) {
    setAirportFilters((prev) => ({
      ...prev,
      localAirports: [
        ...(prev?.localAirports?.filter((item) => item?._id !== id) || []),
      ],
    }));
  }

  function additionalAirportOptionClick(val) {
    if (values?.additionalAirports?.find((item) => item?._id == val?._id))
      return;
    setAirportFilters((prev) => ({
      ...prev,
      additionalAirports: [...(prev?.additionalAirports || []), val],
    }));
  }

  function deleteAdditionalAirport(id) {
    setAirportFilters((prev) => ({
      ...prev,
      additionalAirports: [
        ...(prev?.additionalAirports?.filter((item) => item?._id !== id) || []),
      ],
    }));
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...style }}>
        <Box className={styles["box-container"]}>
          <Typography className={styles.modalTitle}>Search Airport</Typography>

          {/* drodowns */}
          <Grid
            contianer
            sx={{ width: "100%" }}
            className="custom-scroll-design"
          >
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "0.75rem",
              }}
            >
              <InputLabel>Preferred Local Airport</InputLabel>
              <AirportDropdown
                options={options}
                values={values?.localAirports}
                isLoading={isLoading}
                onChange={localAirportOptionClick}
              />
              <Box className={styles["airport-chip-container"]}>
                {values?.localAirports?.map((item) => {
                  return (
                    <CustomAirportChip
                      key={item?._id}
                      label={`${item?.airportName} (${item?.airportCode})`}
                      onDelete={() => deleteLocalAirport(item?._id)}
                    />
                  );
                })}
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "0.75rem",
                mb: "1rem",
              }}
            >
              <Checkbox
                sx={{
                  padding: 0,
                  color: getCssVariableHandler({
                    variableName: "--white-rgb",
                  }),
                }}
                value={values?.sameAsLocal ?? false}
                onChange={(e) => {
                  setAirportFilters((prev) => ({
                    ...prev,
                    sameAsLocal: e?.target?.checked,
                  }));
                }}
              />
              <InputLabel
                sx={{
                  fontSize: "1.1rem !important",
                  fontWeight: "400 !important",
                }}
              >
                Add Same In Additional Airports
              </InputLabel>
            </Grid>

            {!values?.sameAsLocal ? (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "0.75rem",
                }}
              >
                <InputLabel>Other Additional Airport</InputLabel>
                <AirportDropdown
                  options={options}
                  values={values?.additionalAirports}
                  isLoading={isLoading}
                  onChange={additionalAirportOptionClick}
                />
                <Box className={styles["airport-chip-container"]}>
                  {values?.additionalAirports?.map((item) => {
                    return (
                      <CustomAirportChip
                        key={item?._id}
                        label={`${item?.airportName} (${item?.airportCode})`}
                        onDelete={() => deleteAdditionalAirport(item?._id)}
                      />
                    );
                  })}
                </Box>
              </Grid>
            ) : null}

            <Grid item xs={12}>
              <InputLabel>Radius</InputLabel>

              <Box className={styles["slider-container"]}>
                <Slider
                  aria-label="Airport Radius"
                  sx={{
                    "& .MuiSlider-rail": {
                      backgroundColor: "transparent",
                    },
                    "& .MuiSlider-valueLabel": {
                      backgroundColor: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                      color: "white",
                    },
                    "& .MuiSlider-track": {
                      border: "1.5px solid",
                      borderColor: getCssVariableHandler({
                        variableName: "--white-rgb",
                      }),
                      height: 5,
                      boxSizing: "border-box",
                      backgroundClip: "padding-box",
                    },
                    "& .MuiSlider-thumb": {
                      border: "1.5px solid",
                      borderColor: getCssVariableHandler({
                        variableName: "--white-rgb",
                      }),
                    },

                    "& .MuiSlider-mark": {
                      backgroundColor: "#ccc",
                      width: 2,
                      height: 2,
                      borderRadius: "50%",
                    },
                    "& .MuiSlider-markActive": {
                      backgroundColor: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                    },
                    color: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                  }}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(val) => `${val} KM`}
                  step={1}
                  value={values?.radius ?? 50}
                  marks
                  min={0}
                  max={70}
                  onChange={(_, val) =>
                    setAirportFilters((prev) => ({ ...prev, radius: val }))
                  }
                />
                <Typography>{values?.radius} KM</Typography>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ width: "100%" }} className="bottom-btn-box">
            <Button
              sx={{ width: "100%", height: "3.5rem" }}
              className="btn-pink"
              onClick={onClose}
            >
              Done
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

AirportFilterModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  setAirportFilters: PropTypes.func,
  values: PropTypes.object,
  options: PropTypes.array,
  isLoading: PropTypes.bool,
  smallIcon: PropTypes.bool,
};

const AirportDropdown = ({ options, values, onChange, isLoading }) => {
  const [inputVal, setInputVal] = useState("");
  return (
    <Autocomplete
      value={null}
      fullWidth
      options={options}
      onChange={(_, newValue) => {
        setInputVal("");
        onChange(newValue);
      }}
      inputValue={inputVal}
      autoHighlight
      onInputChange={(_, newValue) => setInputVal(newValue)}
      getOptionLabel={(option) =>
        option?.airportName
          ? option?.airportCode
            ? `${option?.airportName} (${option?.airportCode})`
            : option?.airportName
          : ""
      }
      renderOption={(props, option) => (
        <li {...props} key={option._id}>
          {option.airportName}{" "}
          {option?.airportCode ? `(${option?.airportCode})` : ""}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search Airport"
          InputLabelProps={{ style: { color: "white" } }}
          sx={{
            "& .MuiOutlinedInput-root": {
              paddingY: "7px !important",
              "& fieldset": { borderRadius: "8px", borderColor: "white" },
              "&:hover fieldset, &.Mui-focused fieldset": {
                borderColor: "white",
              },
              color: "white",
            },
            "& .MuiInputBase-input": { color: "white" },
            "& .MuiAutocomplete-popupIndicator": { color: "white" },
          }}
        />
      )}
      PaperComponent={({ children }) => (
        <Paper
          sx={{
            background: "black",
            outline: "1px solid white",
            borderRadius: "8px",
            color: "white",
          }}
        >
          {isLoading ? (
            <Box
              sx={{
                padding: "0.5rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={22} />
            </Box>
          ) : options.length === 0 ? (
            <Box
              sx={{
                padding: "0.5rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography>No options</Typography>
            </Box>
          ) : (
            children
          )}
        </Paper>
      )}
    />
  );
};

AirportDropdown.propTypes = {
  options: PropTypes.array,
  values: PropTypes.array,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
};